import i18next from 'i18next'
import moment from 'moment/moment'
import {formatCurrency} from '@/utils'
import { DATE_FORMAT } from '~/code/constants'

export const getColumns = () => {
    return [
        {
            title: i18next.t('SettlementsTransactionsHistoryTable.settlementDate'),
            dataIndex: 'settlementDate',
            key: 'settlementDate',
            render: (date) => moment(date).format(DATE_FORMAT)
        },
        {
            title: i18next.t('SettlementsTransactionsHistoryTable.charged'),
            dataIndex: 'salesAmount',
            key: 'salesAmount',
            render: (value, record) => formatCurrency(value, record.currency)
        },
        {
            title: i18next.t('SettlementsTransactionsHistoryTable.refunds'),
            dataIndex: 'refundsAmount',
            key: 'refundsAmount',
            render: (value, record) => formatCurrency(value, record.currency)
        },
        {
            title: i18next.t('SettlementsTransactionsHistoryTable.fees'),
            dataIndex: 'feesAmount',
            key: 'feesAmount',
            render: (value, record) => formatCurrency(value, record.currency)
        },
        {
            title: i18next.t('SettlementsTransactionsHistoryTable.adjustments'),
            dataIndex: 'adjustmentsAmount',
            key: 'adjustmentsAmount',
            render: (value, record) => formatCurrency(value, record.currency)
        },
        {
            title: i18next.t('SettlementsTransactionsHistoryTable.settlementType'),
            dataIndex: 'settlementType',
            key: 'settlementType'
        },
        {
            title: i18next.t('SettlementsTransactionsHistoryTable.payable'),
            dataIndex: 'settlementAmount',
            key: 'settlementAmount',
            render: (value, record) => formatCurrency(value, record.currency)
        }
    ]
}
